import BaseService from '../base-service';
import StandardResponse from '../../models/standard-response';
import {
    IDriverList,
    IDriverDetail,
    IDriverPaymentDetails,
    IDriverReferralData,
    IBalanceDetails,
    IDriverActivitiesList,
    IDriverDebtorLettersList,
    IcheckReportStatus,
    IDriverSubscriptionsSearch,
    IDriverSubscriptionList,
    IDriverPendingTransactionsList,
} from 'models/driver';
import { IDriverGroup } from 'models/driverGroup';
import { IOrganization } from 'models/user';
import { IRFIDCards, IRFIDCardDetailsData } from 'models/rfid-cards';
import { IPagingColumn } from 'models/common-models';
import { IAddNotesForm } from 'types/stateTypes';
import { IRunHistoryList } from 'models/driver-debt';
export default class DriverService {
    editDriver = async (data: any, id: number): Promise<StandardResponse<{ id: number }>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}`,
                method: 'put',
                data,
            });
            return new StandardResponse<{ id: number }>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverDetail = async (id: number): Promise<StandardResponse<IDriverDetail>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}`,
                method: 'GET',
            });
            return new StandardResponse<IDriverDetail>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverGroups = async (): Promise<StandardResponse<IDriverGroup[]>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/usergroups`,
                method: 'POST',
            });
            return new StandardResponse<IDriverGroup[]>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverList = async (data: any): Promise<StandardResponse<IDriverList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    updateDriverStatus = async (id: number, data: any) => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/change-status`,
                method: 'patch',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getOrganizationList = async (): Promise<StandardResponse<IOrganization[]>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/users/organizations`,
                method: 'POST',
            });
            return new StandardResponse<IOrganization[]>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverTags = async (): Promise<StandardResponse<any>> => {
        try {
            const data = { tag_type: 'DRIVER' };
            const res = await BaseService({
                url: `/v1/admin/tags/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IOrganization[]>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getPaymentDetails = async (id: number): Promise<StandardResponse<IDriverPaymentDetails>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/payment-detail`,
                method: 'get',
            });
            return new StandardResponse<IDriverPaymentDetails>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getReferralDetails = async (id: number, data: any): Promise<StandardResponse<IDriverReferralData>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/referral-detail`,
                method: 'post',
                data,
            });
            return new StandardResponse<IDriverReferralData>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getBalanceDetails = async (id: number): Promise<StandardResponse<IBalanceDetails>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/balance-details`,
                method: 'get',
            });
            return new StandardResponse<IBalanceDetails>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getRFIDCardsList = async (id: number, data): Promise<StandardResponse<IRFIDCards>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/rfid-cards`,
                method: 'post',
                data,
            });
            return new StandardResponse<IRFIDCards>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getRFIDCardDetails = async (id: number, data: any): Promise<StandardResponse<IRFIDCardDetailsData>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/rfid-card-events`,
                method: 'post',
                data,
            });
            return new StandardResponse<IRFIDCardDetailsData>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    startRemoteCharge = async (data: any, mutual_ocpi_version: string): Promise<StandardResponse<any>> => {
        try {
            BaseService.defaults.baseURL = process.env.REACT_APP_OCPI_API_URL;
            const res = await BaseService({
                url: `/ocpi/emsp/${mutual_ocpi_version}/admin/charge-sessions/START_REMOTE_SESSION`,
                method: 'post',
                data,
            });
            BaseService.defaults.baseURL = process.env.REACT_APP_API_SERVER;
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            BaseService.defaults.baseURL = process.env.REACT_APP_API_SERVER;
            return Promise.reject(e);
        }
    };

    resetDriverPassword = async (id: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/reset-password`,
                method: 'put',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    disablePaymentCard = async (id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/disable-payment-card`,
                method: 'patch',
                data: {},
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    deleteDriverAccount = async (id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}`,
                method: 'DELETE',
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    getDriverActivitiesListById = async (
        id: number,
        data: IPagingColumn,
    ): Promise<StandardResponse<IDriverActivitiesList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/activities/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverActivitiesList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverDebtLetters = async (data: any): Promise<StandardResponse<IDriverDebtorLettersList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver-debtor-letters/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverDebtorLettersList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverDebtLettersGenerationStatus = async (): Promise<StandardResponse<IcheckReportStatus>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/check-report-status`,
                method: 'POST',
                data: {},
            });
            return new StandardResponse<IcheckReportStatus>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    generateDriverDebtChaseLetters = async (
        report_type: string,
        template_id: number,
    ): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/generate-chase-report`,
                method: 'POST',
                data: { report_type, template_id },
            });
            return new StandardResponse(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getPastDriverDebtChaseLetters = async (data: IPagingColumn): Promise<StandardResponse<any>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/chase-reports/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<any>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    downloadDriverDebtChaseLetter = async (file_name: string): Promise<void> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/download-debt-letter`,
                method: 'POST',
                data: { file_name: file_name },
            });
            if (res && res.data && res.data.data) {
                window.open(res.data.data);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverSubscriptionList = async (
        data: IDriverSubscriptionsSearch,
    ): Promise<StandardResponse<IDriverSubscriptionList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/driver-premium-subscriptions/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverSubscriptionList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    cancelSubscription = async (driver_premium_subscription_id, data): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/driver-premium-subscriptions/${driver_premium_subscription_id}`,
                method: 'PATCH',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    terminateSubscription = async (driver_premium_subscription_id: number): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/driver-premium-subscriptions/cancel-auto-renewal`,
                data: { driver_premium_subscription_id },
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    addNote = async (driverID: number, data: IAddNotesForm): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/drivers/${driverID}/add-note`,
                method: 'PATCH',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getNotes = async (driverID: number): Promise<StandardResponse<string>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/drivers/${driverID}/view-note`,
                method: 'GET',
            });
            return new StandardResponse<string>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getRunHistoryList = async (data: IPagingColumn): Promise<StandardResponse<IRunHistoryList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/chase-report-data/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IRunHistoryList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    regenerateChaseReport = async (data: {
        chase_report_data_id: number;
        template_id: number;
    }): Promise<StandardResponse<IRunHistoryList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/regenerate-chase-report`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IRunHistoryList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverDebtHistoryListByID = async (
        id: number,
        data: IPagingColumn,
    ): Promise<StandardResponse<IDriverActivitiesList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/debtor-letter-history`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverActivitiesList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    updateReferralCodeStatus = async (id: number, data: any): Promise<StandardResponse<number>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${id}/update-referral-status`,
                method: 'patch',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverpaymentCardsList = async (
        data: any,
        driverId: number,
    ): Promise<StandardResponse<IDriverSubscriptionList>> => {
        try {
            const res = await BaseService({
                url: `/v1/admin/drivers/${driverId}/payment-cards/search`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverSubscriptionList>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };

    getDriverPendingTransactions = async (
        driverId: number,
        data: IPagingColumn,
    ): Promise<StandardResponse<IDriverPendingTransactionsList>> => {
        try {
            const res = await BaseService({
                url: `v1/admin/drivers/${driverId}/filter-driver-pending-transactions`,
                method: 'POST',
                data,
            });
            return new StandardResponse<IDriverPendingTransactionsList>(
                res.status,
                res.data.data,
                res.data.message,
                null,
            );
        } catch (e) {
            return Promise.reject(e);
        }
    };

    cancelPendingTransaction = async (driverId: number, data: { transaction_ids: number[] }) => {
        try {
            const res = await BaseService({
                url: `v1/admin/drivers/${driverId}/cancel-pending-transactions`,
                method: 'POST',
                data,
            });
            return new StandardResponse<number>(res.status, res.data.data, res.data.message, null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
}
